import { AggregationFilter } from './aggregation-filter.model';

export class QueryBase {

    public aggregationFilter?: AggregationFilter;
    constructor(obj?: Partial<QueryBase>) {
        (<any>Object).assign(this, obj);
    }

}

export class Query<TFilter> extends QueryBase {

    public geoSearchFilter?: TFilter;
    public searchFilter?: TFilter;
    public isConsolidatedBox?: boolean;
    public maxZoom?: boolean;
    constructor(obj: Partial<Query<any>>) {
        super();
        (<any>Object).assign(this, obj);
    }

}
